import { render } from "./Main.vue?vue&type=template&id=4376514a"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=4376514a&lang=css"
script.render = render

export default script